import React, { PureComponent } from 'react';

import { connect } from 'react-redux';

import { ModalTransition } from '@atlaskit/modal-dialog';

import { DiffCommentsDialog } from 'src/components/diff-set/diff-comments-dialog';
import { DiffMetadataProps } from 'src/components/diff-set/diff-set';
import { getIsDiffSettingsDialogOpen } from 'src/redux/diff-settings';
import { getIsDeclineDialogOpen } from 'src/redux/pull-request/decline-reducer';
import { getIsUploadImageDialogOpen } from 'src/redux/pull-request/image-upload-reducer';
import { getIsMergeDialogOpen } from 'src/redux/pull-request/merge-reducer';
import {
  getIsOutdatedDialogOpen,
  getIsDiffCommentsDialogOpen,
  getIsNonRenderedDiffCommentsDialogOpen,
  getIsRevertDialogOpen,
  getHiddenFileDialogAnchor,
  getPullRequestSourceHash,
  getPullRequestDestinationHash,
  getPullRequestSourceRepo,
  getPullRequestDestinationRepo,
  getIsReviewDraftDialogOpen,
} from 'src/redux/pull-request/selectors';
import { getIsViewEntireFileDialogOpen } from 'src/redux/pull-request/view-entire-file-reducer';
import { BucketState } from 'src/types/state';

import { DiffSettingsDialog } from '../components/diff-settings';
import { RevertDialog } from '../components/header-actions/revert-pull-request';
import { HiddenFileDialog } from '../components/hidden-file-dialog';
import { MergeDialog } from '../components/merge-dialog';
import NonRenderedDiffCommentsDialog from '../components/non-rendered-diff-comments-dialog';
import { DiffStateContext } from '../components/tabs/diff/diff-state-context';
import { ViewEntireFileDialog } from '../components/view-entire-file';

import { OutdatedCommentsDialog, ReviewDraftDialog } from './comments-dialog';
import DeclineDialog from './decline-dialog';
import { ConnectedImageUploadDialog } from './image-upload-dialog';

type PullRequestDialogZoneProps = {
  diffMetadataProps: DiffMetadataProps;
  hiddenFileDialogAnchor: string | null;
  isDeclineDialogOpen: boolean;
  isMergeDialogOpen: boolean;
  isImageUploadDialogOpen: boolean;
  isOutdatedCommentsDialogOpen: boolean;
  isDiffCommentsDialogOpen: boolean;
  isNonRenderedDiffCommentsDialogOpen: boolean;
  isDiffSettingsDialogOpen: boolean;
  isRevertDialogOpen: boolean;
  isViewEntireFileDialogOpen: boolean;
  isReviewDraftDialogOpen: boolean;
};

const mapStateToProps = (state: BucketState) => {
  const diffMetadataProps: DiffMetadataProps = {
    sourceHash: getPullRequestSourceHash(state) || '',
    destinationHash: getPullRequestDestinationHash(state) || '',
    sourceRepoFullSlug: getPullRequestSourceRepo(state)?.full_name || '',
    destinationRepoFullSlug:
      getPullRequestDestinationRepo(state)?.full_name || '',
  };
  return {
    diffMetadataProps,
    hiddenFileDialogAnchor: getHiddenFileDialogAnchor(state),
    isDeclineDialogOpen: getIsDeclineDialogOpen(state),
    isMergeDialogOpen: getIsMergeDialogOpen(state),
    isImageUploadDialogOpen: getIsUploadImageDialogOpen(state),
    // If we can't find the file then don't even open it. Stale permalinks can do this.
    isOutdatedCommentsDialogOpen: getIsOutdatedDialogOpen(state),
    isReviewDraftDialogOpen: getIsReviewDraftDialogOpen(state),
    isDiffCommentsDialogOpen: getIsDiffCommentsDialogOpen(state),
    isNonRenderedDiffCommentsDialogOpen:
      getIsNonRenderedDiffCommentsDialogOpen(state),
    isDiffSettingsDialogOpen: getIsDiffSettingsDialogOpen(state),
    isRevertDialogOpen: getIsRevertDialogOpen(state),
    isViewEntireFileDialogOpen: getIsViewEntireFileDialogOpen(state),
  };
};

export const PullRequestDialogZone = connect(mapStateToProps)(
  class BasePullRequestDialogZone extends PureComponent<PullRequestDialogZoneProps> {
    render() {
      const {
        diffMetadataProps,
        hiddenFileDialogAnchor,
        isMergeDialogOpen,
        isDeclineDialogOpen,
        isImageUploadDialogOpen,
        isOutdatedCommentsDialogOpen,
        isDiffCommentsDialogOpen,
        isNonRenderedDiffCommentsDialogOpen,
        isDiffSettingsDialogOpen,
        isRevertDialogOpen,
        isViewEntireFileDialogOpen,
        isReviewDraftDialogOpen,
      } = this.props;

      return (
        <DiffStateContext.Consumer>
          {({
            iterativeReviewSelectedDiff,
            setIterativeReviewSelectedDiff,
          }) => {
            return (
              <ModalTransition>
                {isMergeDialogOpen && <MergeDialog />}
                {isDeclineDialogOpen && <DeclineDialog />}
                {isImageUploadDialogOpen && <ConnectedImageUploadDialog />}
                {/* @ts-ignore: requires @atlaskit/router to be bumped after AKR-23 released */}
                {isOutdatedCommentsDialogOpen && (
                  <OutdatedCommentsDialog
                    selectedDiffType={
                      iterativeReviewSelectedDiff.selectedDiffType
                    }
                    setIterativeReviewSelectedDiff={
                      setIterativeReviewSelectedDiff
                    }
                  />
                )}
                {isReviewDraftDialogOpen && <ReviewDraftDialog />}
                {isDiffCommentsDialogOpen && <DiffCommentsDialog />}
                {!!hiddenFileDialogAnchor && (
                  <HiddenFileDialog anchor={hiddenFileDialogAnchor} />
                )}
                {isRevertDialogOpen && <RevertDialog />}
                {isNonRenderedDiffCommentsDialogOpen && (
                  <NonRenderedDiffCommentsDialog />
                )}
                {isDiffSettingsDialogOpen && <DiffSettingsDialog />}
                {isViewEntireFileDialogOpen && (
                  <ViewEntireFileDialog diffMetadataProps={diffMetadataProps} />
                )}
              </ModalTransition>
            );
          }}
        </DiffStateContext.Consumer>
      );
    }
  }
);
